import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		language: process.env.DEFAULT_LOCALE,
		config: {
			url: process.env.VUE_APP_URL
		},
		auth: {
			id: null,
			emailAddress: null,
			token: null,
			language: process.env.DEFAULT_LOCALE
		}
	},
	mutations: {},
	actions: {},
	modules: {}
})
